<script>

  export default {
    name: "Index",
    render: function (createElement, context) {
      //todo - redirect depending on if there is current session active
      window.location.href = '/login';
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Index.vue